import type { FirstMeaningfulPaintContext } from '@ms/yammer-telemetry-support';

import { createNamespacedStorageValue } from './namespacedStorageValue';

const getDefaultFirstMeaningfulPaintContext = (): FirstMeaningfulPaintContext => ({
  firstMeaningfulPaintReported: false,
  firstPageLoadReported: false,
  firstPageLoadAbandoned: false,
});

const firstMeaningfulPaint = createNamespacedStorageValue<FirstMeaningfulPaintContext>(
  'FirstMeaningfulPaintContext',
  getDefaultFirstMeaningfulPaintContext
);

export const getFirstMeaningfulPaintContext = (): FirstMeaningfulPaintContext => firstMeaningfulPaint.get();
export const setFirstMeaningfulPaintContext = (firstMeaningfulPaintContext: FirstMeaningfulPaintContext): void => {
  firstMeaningfulPaint.set(firstMeaningfulPaintContext);
};
export const removeFirstMeaningfulPaintContext = (): void => {
  firstMeaningfulPaint.remove();
};
